import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailDocument {
  id: number;
  name: string;
  url: string;
}

export const prepareDetailPropertyDocuments = (
  data: IPropertyDetailsResponse
): IPropertyDetailDocument[] => {
  console.log(data.documents);
  return (
    data?.documents?.map(document => ({
      id: document.id,
      name: document.type.description,
      url: document.filename
    })) || []
  );
};
